import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CreateProductForm from '@/components/learing-registry/create-product-form/create-product-form';

@Component({
    name: 'create-product',
    components: {
       'add-new-product': CreateProductForm,
    },
})

export default class CreateProduct extends Vue {


    // -----------------------------------------------------------------------
    // Properties

    @Prop()
    private toolPartners: any;

    private isLoading: boolean = false;

    // ---------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/partner-catalog/content-registry');
    }

    private onAddPublisher(publisherInfo: any) {
        this.createdPublisher(publisherInfo);
    }

    // ---------------------------------------------------------------------
    // Methods

    private createdPublisher(publisherInfo: any) {
        this.isLoading = true;
        learningRegistryAPI.savePublisher(publisherInfo).then((publisherData) => {
            this.isLoading = false;
            this.$router.push('/partner-catalog/content-registry');
        });
    }

}
